import app from 'flarum/forum/app';
import Footer from './components/CustomFooter';
import { extend } from 'flarum/common/extend';
import ForumApplication from 'flarum/forum/ForumApplication';

app.initializers.add('dvdfab/footer', () => {
 extend(ForumApplication.prototype, 'mount', function () {
    // 保证只挂一次
    if (!document.querySelector('.dvdfab-footer')) {
      const appContent = document.getElementById('app');
      const footerRoot = document.createElement('div');
      appContent?.appendChild(footerRoot);
      m.mount(footerRoot, Footer);
    }
  });

});
